import { createAsyncThunk } from "@reduxjs/toolkit";

import ChargesAPI, {
  CreateChargeParams,
  AddAssetLinkagesParams,
  AddAssetLinkagesResponse,
  AddLoanLinkagesParams,
  AddLoanLinkagesResponse,
  GetChargesResponse,
  ChargeWithLinkages,
} from "../../../api/charges";
import { RootState } from "../../../app/store";

export const fetchCharges = createAsyncThunk<
  GetChargesResponse,
  string,
  {state: RootState; rejectValue: string;}
>(
  "charges/fetchCharges",
  async (caseId, { rejectWithValue }) => {
    try {
      const response =
        await ChargesAPI.getCharges({
          case_id: caseId,
        });

      return response;
    } catch {
      return rejectWithValue("Failed to fetch charges");
    }
  },
  {
    condition(caseId, { getState }) {
      const chargesState = getState().charges;

      if (chargesState.caseId === caseId && 
        (chargesState.status === "loading" || chargesState.status === "success")) 
      {
        return false;
      }

      return true;
    },
  },
);

export const createCharge = createAsyncThunk<
  ChargeWithLinkages,
  CreateChargeParams,
  { rejectValue: string }
>(
  "charges/createCharge",
  async (
    params,
    { rejectWithValue },
  ) => {
    try {
      const response =
        await ChargesAPI.createCharge(params);

      return response;
    } catch {
      return rejectWithValue("Failed to create charge");
    }
  },
);

export const addAssetLinkages =
  createAsyncThunk<
    AddAssetLinkagesResponse,
    AddAssetLinkagesParams,
    { rejectValue: string }
  >(
    "charges/addAssetLinkages",
    async (
      params,
      { rejectWithValue },
    ) => {
      try {
        const response =
          await ChargesAPI.addAssetLinkages(
            params,
          );

        return response;
      } catch {
        return rejectWithValue("Failed to add asset linkages");
      }
    },
  );

export const addLoanLinkages =
  createAsyncThunk<
    AddLoanLinkagesResponse,
    AddLoanLinkagesParams,
    { rejectValue: string }
  >(
    "charges/addLoanLinkages",
    async (
      params,
      { rejectWithValue },
    ) => {
      try {
        const response =
          await ChargesAPI.addLoanLinkages(
            params,
          );

        return response;
      } catch {
        return rejectWithValue("Failed to add loan linkages");
      }
    },
  );